export enum NorthCapitalYesNoBoolean {
    Yes = 'yes',
    No = 'no',
}
